import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { border, spacing, color, breakpoint } from '../theme'
import { SectionHeader } from '../atoms/SectionHeader'
import { Table, TableHeader, TableRow, TableRowTitle } from '../molecules/Table'

const Wrapper = styled.div`
   padding: ${spacing.m} ${spacing.sm};
   border-radius: ${border.radius};
   border: 2px solid ${color.primary};

   @media screen and (min-width: ${breakpoint.m}) {
      padding: ${spacing.m} ${spacing.l};
   }
`
/**
 * Sort all booking dates by week
 * @param reviewData: {} // booking list
 * @returns: [week number: [{}]]
 */
const sortByWeek = review => {
   let reviewList = []

   review &&
      review.forEach(date => {
         const week = moment(date.date).isoWeek()
         const stringDate = moment(date.date).format('dddd, MMM D')
         const bookings = date.schedules.filter(
            booking => booking.pickUp && booking.dropOff
         )

         if (!reviewList[week]) {
            reviewList[week] = []
         }

         reviewList[week].push({
            week: week,
            date: stringDate,
            bookings: bookings
         })
      })

   return reviewList
}

/**
 * GetDayRow
 * @param day : []
 * @return {} // elements
 */
const getDayRow = day => {
   if (!day || day.length === 0) {
      return (
         <p>
            <i>No booking (Fritids available)</i>
         </p>
      )
   }

   return day.map((child, key) => (
      <TableRow key={key}>
         <p>{child.name}</p>
         <p>{child.dropOff}</p>
         <p>{child.pickUp}</p>
      </TableRow>
   ))
}

/**
 * ReviewTable
 * Refactor review data and create review table
 *
 * @param review
 * @return {*}
 */
export const ReviewTable = ({ review }) => {
   const schedulesData = sortByWeek(review)

   const getReviewTableRows = () => {
      return schedulesData.map((weekData, key) => {
         return (
            <div key={key}>
               <SectionHeader title={'Week: ' + key} />
               <Table>
                  <TableHeader>
                     <p>Day & Child</p>
                     <p>Drop off</p>
                     <p>Pick up</p>
                  </TableHeader>
                  {weekData.map((day, index) => (
                     <div key={index}>
                        <TableRowTitle key={index}>
                           <p>{day.date}</p>
                        </TableRowTitle>
                        {getDayRow(day.bookings)}
                     </div>
                  ))}
               </Table>
            </div>
         )
      })
   }

   return (
      <Wrapper>
         <Table>{getReviewTableRows()}</Table>
      </Wrapper>
   )
}
